var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      !_vm.autocomplete && !_vm.iterator
        ? _c("v-select", {
            ref: "select",
            attrs: {
              multiple: _vm.multiple,
              items: _vm.getInstruments,
              value: _vm.value,
              "item-text": "name",
              "item-value": "id",
              label: _vm.label ?? `Instrument${_vm.multiple ? "s" : ""}`,
              "prepend-inner-icon": _vm.hideIcon ? null : "music_note",
              rules: _vm.rules,
              outlined: "",
              clearable: _vm.clearable,
              dense: "",
              "hide-details": _vm.hideDetails,
              "return-object": !_vm.multiple && _vm.returnObject,
              disabled: _vm.disabled,
              "menu-props": {
                auto: true,
                contentClass: "mx-2",
              },
              readonly: _vm.readonly,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              focus: function ($event) {
                return _vm.$emit("focus")
              },
              "click:clear": function ($event) {
                return _vm.$emit("clear")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.autocomplete
        ? _c("v-autocomplete", {
            staticClass: "soli-blue-text",
            attrs: {
              value: _vm.value,
              disabled: _vm.disabled,
              items: _vm.getInstruments,
              rules: _vm.rules,
              "error-messages": _vm.error,
              "hide-details": _vm.hideDetails,
              autofocus: _vm.autofocus,
              label: _vm.label ?? `Instrument${_vm.multiple ? "s" : ""}`,
              "prepend-inner-icon": _vm.hideIcon ? null : "music_note",
              "item-text": "name",
              "item-value": "id",
              outlined: "",
              dense: "",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c(
                        "v-list-item-avatar",
                        { staticClass: "shadow-blue", attrs: { size: "56" } },
                        [
                          data.item.photo_url
                            ? _c("img", {
                                attrs: {
                                  src: `${data.item.photo_url}/m/80x80`,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.icon
                            ? _c("v-icon", { attrs: { color: "accent" } }, [
                                _vm._v(_vm._s(data.item.icon)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !data.item.photo_url && !data.item.icon
                            ? _c("img", {
                                attrs: { src: "/musicologie-m-white.png" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            staticClass: "font-weight-bold body-2",
                            domProps: { innerHTML: _vm._s(data.item.name) },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              564255921
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iterator && _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto my-3",
            attrs: {
              type: "list-item-avatar, list-item-avatar, list-item-avatar",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iterator && !_vm.loading
        ? _c("v-data-iterator", {
            attrs: {
              items: _vm.getInstruments,
              "disable-pagination": "",
              search: _vm.search,
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "v-sheet",
                        {
                          staticStyle: {
                            position: "sticky",
                            top: "0px",
                            "z-index": "10",
                          },
                          attrs: { light: "" },
                        },
                        [
                          _c("SoliText", {
                            staticClass: "pa-3",
                            attrs: {
                              icon: "music_note",
                              autofocus: _vm.autofocus,
                              label: "Search Instruments",
                              hideDetails: "",
                              fullRound: "",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c(
                        "v-list",
                        { staticClass: "py-0 px-3 soli-round" },
                        [
                          _c("SoliAvatarBtn", {
                            staticClass: "w-full",
                            attrs: {
                              blueShadow: "",
                              avatar: data.item.icon
                                ? null
                                : data.item.photo_url
                                ? `${data.item.photo_url}/m/80x80`
                                : "/musicologie-m-white.png",
                              outlined: false,
                              title: data.item.name,
                              icon: data.item.icon ?? null,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "input",
                                  _vm.returnObject ? data.item : data.item.id
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              672329027
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }